import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { z } from 'zod'

import PageSkeleton from '@/core/components/page-skeleton'
import RouteError from '@/core/components/route-error'
import { queryClient } from '@/core/lib/query-client'
import { routeHasPermission } from '@/core/utils/auth-utils'

import { dashboardRoute } from '@/modules/dashboard/dashboard.routes'
import { auditPagedQueryOptions } from '@/modules/audit/audit.hooks'

// TanStack Router search değerlerini JSON çözer → page sayı; boş filtreler URL'den düşer.
const auditSearchSchema = z.object({
  page: z.number().optional(),
  actor: z.string().optional(),
  action: z.string().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
})

export const auditRoute = createRoute({
  path: '/audit-logs',
  getParentRoute: () => dashboardRoute,
  errorComponent: ({ error, reset }) => (
    <RouteError error={error} reset={reset} />
  ),
})

export const auditListRoute = createRoute({
  getParentRoute: () => auditRoute,
  path: '/',
  validateSearch: auditSearchSchema,
  beforeLoad: ({ preload }) =>
    routeHasPermission(
      preload,
      'audit.read',
      'Denetim izine erişim izniniz yok.'
    ),
  loaderDeps: ({ search }) => ({
    page: search.page ?? 1,
    actor: search.actor ?? '',
    action: search.action ?? '',
    from: search.from ?? '',
    to: search.to ?? '',
  }),
  loader: ({ deps }) =>
    queryClient.ensureQueryData(
      auditPagedQueryOptions(deps.page, {
        actor: deps.actor || undefined,
        action: deps.action || undefined,
        from: deps.from || undefined,
        to: deps.to || undefined,
      })
    ),
  head: () => ({ meta: [{ title: 'Denetim İzi' }] }),
  pendingComponent: () => <PageSkeleton />,
  pendingMs: 100,
  component: lazyRouteComponent(
    () => import('@/modules/audit/pages/list-audit.page')
  ),
})
